/*
 * portalModal Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 12-Oct-2022
 */

export const actionTypes = {
  FLOW_POPUP: 'FLOW_POPUP',
  // @generator action:type
  // @generator action:type:request
};

// ------------------------------------
// Actions
export function goPopup(popup, moreInfo) {
  return {
    type: actionTypes.FLOW_POPUP,
    payload: { popup, moreInfo },
  };
}
// ------------------------------------
// @generator action:request
// @generator action
